import { render, staticRenderFns } from "./map-mobile-suggestions.vue?vue&type=template&id=53ef3804&scoped=true"
import script from "./map-mobile-suggestions.vue?vue&type=script&lang=js"
export * from "./map-mobile-suggestions.vue?vue&type=script&lang=js"
import style0 from "./map-mobile-suggestions.vue?vue&type=style&index=0&id=53ef3804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ef3804",
  null
  
)

export default component.exports